<template>
  <div
    class="c-card van-hairline--top-bottom"
    style="border-top: 1px solid #D8D8D8;border-bottom: 1px solid #D8D8D8;"
  >
    <p style="display:flex;align-items: center;font-size: 16px;font-weight: bold;color: #00C896">
      <!-- <svg
        v-if="icon"
        class="icon closeImg"
        aria-hidden="true"
        style="width: 18px;height: 18px;margin-right: 3px;"
      >
        <use xlink:href="#icon-buqian"></use></svg
      > -->
      {{ title }}
    </p>
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: {
    icon: {
      type: Boolean
    },
    title: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="scss" scoped>
.c-card {
  margin-top: 10px;
  padding: 16px;
  background-color: #fff;
  &:last-of-type {
    margin-bottom: 10px;
  }
}
</style>
